import { Route } from 'react-router-dom';

import { SectionLayout } from 'shared/ui/layout';
import { COUNTRIES, COUNTRY } from 'shared/consts/routes/country';
import { ADD_PREFIX } from 'shared/consts/routes/common';

import { RequireAuth } from 'entities/authorization';
import { ConnectedCountriesMenu } from 'entities/country';

import { AddCountryPage, EditCountryPage } from 'pages/country';

export const CountryRoutes = (
  <Route element={<RequireAuth controllerName="Country" rightType="Read" />}>
    <Route
      path={COUNTRIES}
      element={<SectionLayout menu={<ConnectedCountriesMenu />} />}
    >
      <Route
        element={<RequireAuth controllerName="Country" rightType="Write" />}
      >
        <Route path={ADD_PREFIX} element={<AddCountryPage />} />
      </Route>
      <Route path={COUNTRY} element={<EditCountryPage />} />
    </Route>
  </Route>
);
